import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { useIntl } from "react-intl";

import SavedAddressType from "@mapmycustomers/shared/enum/SavedAddressType";
import SavedAddress from "@mapmycustomers/shared/types/SavedAddress";

import getSavedAddressDisplayName from "@app/util/savedLocations/getSavedAddressDisplayName";
import { getSavedAddressLine } from "@app/util/savedLocations/savedAddressList";

import styles from "./CommonRow.module.scss";
import savedAddressIcons from "./savedAddressIcons";

export interface SavedAddressRowProps {
  savedAddress: SavedAddress;
}

const SavedAddressRow = ({ savedAddress }: SavedAddressRowProps) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <span
        className={cn(styles.glyph, {
          [styles.custom]: savedAddress.type === SavedAddressType.CUSTOM,
        })}
      >
        <FontAwesomeIcon icon={savedAddressIcons[savedAddress.type]} />
      </span>
      <div className={styles.text}>
        <div className={styles.title}>{getSavedAddressDisplayName(intl, savedAddress)}</div>
        <div className={styles.subtitle}>{getSavedAddressLine(savedAddress)}</div>
      </div>
    </div>
  );
};

export default SavedAddressRow;
